import React, { Fragment, useContext, useEffect, useState } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate, useParams } from "react-router-dom";
import { sendApiRequest } from "../../services/Base/base-service";

import SubNavigation from "../../components/Header/SubNavigation";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Alert,
  Card,
  CardBody,
  CardCategory,
  CardText,
  Col,
  Icon,
  Row,
  Section,
  Spinner,
} from "design-react-kit";

import UserContext from "../../store/user-context";
import PDFSidebar from "../../components/PfdSidebar";
import NotificationEditForm from "../../components/Forms/NotificationEditForm";
import secureLocalStorage from "react-secure-storage";
import ConfirmDeleteModal from "../../components/Modals/ConfirmDeleteModal";

const DocumentCheck = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [collapseOpen, setCollapseOpen] = useState(true);
  const [groups, setGroups] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [results, setResults] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const params = useParams();
  const clientId = params?.clientId;
  const clientName = params?.client;

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    getAllFileGroupsHandler(clientId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllFileGroupsHandler = (clientId) => {
    setIsLoading(true);
    sendApiRequest(
      `DocumentCheck/GetAllFileGroups?clientId=${clientId}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setGroups(response.data.fileGroups);
          setIsLoading(false);
        }
      }
    });
  };

  const runDocumentCheckHandler = (fileSetPrefix, clientId) => {
    setIsLoading(true);
    setError(null);
    sendApiRequest(
      `DocumentCheck/RunDocumentCheck`,
      "POST",
      true,
      {
        clientId,
        fileSetPrefix,
      },
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setResults(null);
          setCollapseOpen(false);
          setIsLoading(false);
        } else {
          setTimeout(() => {
            getDocumentCheckResultHandler(response.data);
            secureLocalStorage.setItem("documentCheckResultId", response.data);
          }, 400);
          setTimeout(() => {
            getAllFileGroupsHandler(clientId);
          }, 500);
          setIsLoading(false);
        }
      }
    });
  };

  const getDocumentCheckResultHandler = (IdDocumentCheckResult) => {
    setIsLoading(true);
    setError(null);
    sendApiRequest(
      `DocumentCheck/GetDocumentCheckResult?DocumentCheckResultId=${IdDocumentCheckResult}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setResults(response.data);
          setIsLoading(false);
          setCollapseOpen(false);
        }
      }
    });
  };

  const deleteFileGroupHandler = (filesetPrefix) => {
    setSelectedGroup(filesetPrefix);
    setIsLoading(true);
    setError(null);
    sendApiRequest(
      `DocumentCheck/DeleteFileGroup/${clientId}/${filesetPrefix}`,
      "DELETE",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setModalOpen(false);
          setSelectedGroup(null);
          setResults(null);
          setTimeout(() => {
            getAllFileGroupsHandler(clientId);
          }, 100);
        }
      }
    });
  };

  const cardClickHandler = (e, group) => {
    const cards = document.querySelectorAll(".card-bg");
    cards.forEach((card) => card.classList.remove("active-card"));
    e.target.closest(".card-bg").classList.add("active-card");
    if (
      group.documentCheckResultId !== 0 &&
      group.documentCheckResultId !== null &&
      group.documentCheckResultId !== undefined
    ) {
      getDocumentCheckResultHandler(group.documentCheckResultId);
      secureLocalStorage.setItem(
        "documentCheckResultId",
        group.documentCheckResultId
      );
    } else {
      runDocumentCheckHandler(group.prefix, clientId);
    }
  };

  const modalOpenHandler = (group) => {
    setSelectedGroup(group);
    setModalOpen(true);
  };

  const modalCloseHandler = () => {
    setModalOpen(false);
    setSelectedGroup(null);
  };

  return (
    <Fragment>
      <SubNavigation page="check" results={results} />
      <Section>
        <Alert color="info" id="edit-alert">
          <p>
            Questa funzionalità ti consente di verificare la configurazione
            impostata fino a questo momento per la tipologia di servizio{" "}
            <span className="font-weight-bold"> {clientName} </span>{" "}
            applicandola ad uno dei gruppi di files (insieme di files riferiti
            alla stessa notifica per cui esiste già una configurazione, anche
            parziale, basata sul tipo di documento riconosciuto) riportati di
            seguito:
          </p>
        </Alert>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && <Spinner double active />}
        <Accordion iconLeft className="mb-4">
          <AccordionHeader
            active={collapseOpen}
            onToggle={() => setCollapseOpen(!collapseOpen)}
          >
            Gruppi di files
          </AccordionHeader>
          <AccordionBody active={collapseOpen}>
            <Row>
              {groups !== null &&
                groups.map((group) => {
                  return (
                    <Col key={group.prefix} xs="12" md="6" lg="4">
                      <Card
                        id={group.prefix}
                        name={group.prefix}
                        spacing
                        className="card-bg rounded pb-0"
                        role="button"
                        onClick={(e) => cardClickHandler(e, group)}
                      >
                        <div
                          key={group.prefix}
                          className="d-flex align-items-center justify-content-end"
                          onClick={(e) => {
                            e.stopPropagation();
                            modalOpenHandler(group.prefix);
                          }}
                        >
                          <span>Rimuovi</span>
                          <Icon icon="it-close" className="m-0" />
                        </div>
                        <CardBody className="pb-0 pr-1">
                          <CardCategory iconName="it-file">
                            <h6 className="font-weight-bold">{group.prefix}</h6>
                          </CardCategory>
                          <CardText>
                            <ul className="ml-5 mb-0">
                              {group.fileNames.map((name) => {
                                return (
                                  <li style={{ fontSize: "1rem" }}>{name}</li>
                                );
                              })}
                            </ul>
                          </CardText>
                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}
            </Row>
          </AccordionBody>
        </Accordion>
        {results !== null && results.notificationFiles.length > 0 && (
          <div className="content d-flex">
            <PDFSidebar files={results.notificationFiles} />
            <NotificationEditForm
              notificationData={results.notificationData}
              invalidProperties={results.invalidProperties}
            />
          </div>
        )}
        <ConfirmDeleteModal
          confirmModalOpen={modalOpen}
          confirmModalCloseHandler={modalCloseHandler}
          flowId={selectedGroup}
          target={selectedGroup}
          error={error}
          isLoading={isLoading}
          text={"Stai per eliminare gruppo di files"}
          actionHandler={deleteFileGroupHandler}
          confirmButtonText="Sì, elimina"
        />
      </Section>
    </Fragment>
  );
};

export default DocumentCheck;
